import React from "react";
import { Form, Button, Row, Col, Card } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import DommusRequiredSpan from "../../../../components/DommusRequiredSpan";
import "./index.scss";

export function ActionsComponent({ actionsRespostas, setActionsRespostas }) {
  const handleAdicionarBloco = () => {
    setActionsRespostas((prev) => [...prev, { title: "", id: "" }]);
  };

  const handleRemoverBloco = (index) => {
    setActionsRespostas((prev) => prev.filter((_, i) => i !== index));
  };

  const handleAlterarCampo = (index, campo, valor) => {
    setActionsRespostas((prev) =>
      prev.map((item, i) => (i === index ? { ...item, [campo]: valor } : item))
    );
  };

  return (
    <div className="actions-component">
      <Row className="mb-2 align-items-center">
        <Col>
          Respostas Rápidas <DommusRequiredSpan />
        </Col>
        <Col className="d-flex justify-content-end">
          <Button variant="success" size="sm" onClick={handleAdicionarBloco}>
            <FontAwesomeIcon icon={faPlus} className="mr-1" /> Adicionar Resposta
          </Button>
        </Col>
      </Row>
      {actionsRespostas.length === 0 && (
        <p className="text-muted text-center">
          Nenhuma resposta adicionada. Clique em "Adicionar Resposta" para começar.
        </p>
      )}
      <div className="actions-list">
        {actionsRespostas.map((item, index) => (
          <Card key={index} className="mb-2">
            <Card.Body>
              <Row className="align-items-end">
                <Col md={5}>
                  <Form.Group className="mb-0">
                    <Form.Label>
                      Título <DommusRequiredSpan />
                    </Form.Label>
                    <Form.Control
                      type="text"
                      value={item.title}
                      onChange={(e) => handleAlterarCampo(index, "title", e.target.value)}
                      placeholder="Ex: Confirmar"
                    />
                  </Form.Group>
                </Col>
                <Col md={5}>
                  <Form.Group className="mb-0">
                    <Form.Label>
                      ID <DommusRequiredSpan />
                    </Form.Label>
                    <Form.Control
                      type="text"
                      value={item.id}
                      onChange={(e) => handleAlterarCampo(index, "id", e.target.value)}
                      placeholder="Ex: confirmar_1"
                    />
                  </Form.Group>
                </Col>
                <Col md={2} className="d-flex justify-content-end">
                  <Button
                    variant="danger"
                    size="sm"
                    onClick={() => handleRemoverBloco(index)}
                    title="Remover"
                  >
                    <FontAwesomeIcon icon={faTrash} />
                  </Button>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        ))}
      </div>
    </div>
  );
}
